import { QueryOperatorInput, WithPayoutDescriptor } from '@frontend/api-payments';

export interface Destination {
  destinationId: string;
  accountName: string;
  brand: string;
  country: string;
  currency: string;
  destinationType: 'CARD' | 'BANK';
  fingerprint: string;
  last4: string;
  routingNumber: string;
  createdAt: string;
}

export interface PayoutTransaction {
  __typename?: string; //GQL
  amount: number;
  createdAt: string;
  currency: string;
  eta: string;
  fee: number;
  firstName: string;
  lastName: string;
  net: number;
  pmid: string;
  status: string;
  transactionId: string;
  transactionType: string;
  transactionDate: string;
}

export interface PayoutTransactions {
  items: PayoutTransaction[];
}

export interface PayoutModel {
  payoutId: string;
  amount: number;
  status: PayoutStatus;
  createdAt: string;
  estimatedArrivalOn: string;
  destination: Destination;
  transactions: PayoutTransactions;
  summary: PayoutSummary;
  locationId?: string[];
}

export interface PayoutEdge {
  node: PayoutModel;
  cursor: string;
}

export interface BalanceSummaryModel {
  currency: string;
  total: number;
  available: number;
  inTransit: number;
}

export enum PayoutStatus {
  Paid = 'PAID',
  Pending = 'PENDING',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
}
export interface PayoutSummary {
  items: PayoutSummaryItem[];
  total: number;
}

export interface PayoutSummaryItem {
  itemType: PayoutSummaryItemType;
  count: number;
  gross: number;
  fees: number;
  net: number;
}

export enum PayoutSummaryItemType {
  Charges = 'CHARGES',
  ApplicationFees = 'APPLICATION_FEES',
  Refunds = 'REFUNDS',
  Adjustments = 'ADJUSTMENTS',
}

export interface PayoutListFilter {
  amount?: QueryOperatorInput<number>;
  arrival?: QueryOperatorInput<string>;
  status?: PayoutStatus;
  descriptor?: string;
  locationId?: string[];
}

export interface PayoutListQueryVariables {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  filter?: PayoutListFilter;
}

export interface PayoutListPaginationOptions {
  page?: number;
  pageSize?: number;
}

export interface PayoutListQueryResponse {
  payouts: {
    __typename: string;
    edges: PayoutEdge[];
    pageInfo: {
      hasPreviousPage: boolean;
      hasNextPage: boolean;
      startCursor: string;
      endCursor: string;
    };
  };
}

export interface BalanceQueryResponse {
  balance: BalanceSummaryModel;
}

export type PayoutWithDescriptor = WithPayoutDescriptor<PayoutModel>;
